import { useState } from 'react'

import { withBase } from '../lib/basePath'
import { color, radius } from '../theme/tokens'

/**
 * Marca do Hub de Cobrança.
 *
 * Usa `public/logo.png` quando o arquivo existe e cai para uma marca vetorial
 * genérica caso contrário — assim o app sobe mesmo antes do asset definitivo
 * estar no lugar, e passa a usá-lo assim que ele aparecer.
 */
export function Logo({ size = 28 }: { size?: number }) {
  const [failed, setFailed] = useState(false)

  if (!failed) {
    return (
      <img
        src={withBase('logo.png')}
        alt="Hub de Cobrança"
        onError={() => setFailed(true)}
        style={{
          width: size,
          height: size,
          borderRadius: radius.md - 1,
          background: '#fff',
          objectFit: 'contain',
          flex: 'none',
        }}
      />
    )
  }

  return (
    <svg
      viewBox="0 0 32 32"
      role="img"
      aria-label="Hub de Cobrança"
      style={{ width: size, height: size, borderRadius: radius.md - 1, background: '#fff', flex: 'none' }}
    >
      <rect width="32" height="32" rx="7" fill="#fff" />
      <g fill="none" stroke={color.brand} strokeWidth="2.4" strokeLinejoin="round">
        <path d="M16 6 26 11l-10 5-10-5z" />
      </g>
      <g fill="none" stroke={color.panel} strokeWidth="2.2" strokeLinejoin="round" opacity="0.9">
        <path d="M6 16l10 5 10-5" />
        <path d="M6 21l10 5 10-5" />
      </g>
    </svg>
  )
}
